import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const WaveText = ({ text }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: 0.2,
        triggerOnce: true
    });

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView]);

    return (
        <div className="wave-text-container" ref={ref}>
            {text.split('').map((char, index) => (
                <motion.span
                    key={index}
                    initial={{ opacity: 0, y: 50 }}
                    animate={controls}
                    variants={{
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.15,  // Reduced from 0.3
                                delay: index * 0.07  // Reduced from 0.1
                            }
                        }
                    }}
                    className="wave-text-char"
                >
                    {char}
                </motion.span>
            ))}
        </div>
    );
};

export default WaveText;
